import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteTrajectories, getTrajectoriesList } from '../../actions/trajectories'
import Loader from '../../components/Loader'
import Empty from '../../components/Empty'
export default function Index() {
    const dispatch = useDispatch();
    const { list, loading } = useSelector(state => state.trajectories)

    const [selectedItem,
        setSelectedItem] = useState(null)
    const [confirmation,
        setConfirmation] = useState(false);
    const [sortField, setSortField] = useState('name')
    const [sortAsc, setSortAsc] = useState(true)

    useEffect(() => {
        dispatch(getTrajectoriesList())
    }, [])

    const handleSort = (field) => {
        if (sortField === field) setSortAsc(v => !v)
        else { setSortField(field); setSortAsc(true) }
    }

    const sortedList = useMemo(() => {
        if (!list) return []
        return [...list].sort((a, b) => {
            const aVal = a[sortField] ?? ''
            const bVal = b[sortField] ?? ''
            if (typeof aVal === 'number' && typeof bVal === 'number')
                return sortAsc ? aVal - bVal : bVal - aVal
            return sortAsc
                ? String(aVal).localeCompare(String(bVal), 'ru')
                : String(bVal).localeCompare(String(aVal), 'ru')
        })
    }, [list, sortField, sortAsc])

    const openModal = (data) => () => {
        setSelectedItem(data)
    }

    const closeModal = () => setSelectedItem(null)

    const acceptConfirmation = () => {
        closeModal();
        dispatch(deleteTrajectories(confirmation.id));
        setConfirmation(false);
    };
    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const renderLi = (data) => {
        const { id, name, alias } = data
        return (
            <tr >
                <td onClick={openModal(data)}>{name}</td>
                <td onClick={openModal(data)}>{alias}</td>
                <td>
                    <i
                        className={styles.trash}
                        onClick={() => setConfirmation({ id, name: name })}><BiTrash /></i>
                </td>
            </tr>
        )
    }

    return (
        <div
            className={styles.wrapper}
            style={{
                width: '100%',
                margin: '0 auto'
            }}>
            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation
                    ?.id)}
                rejectConfirmation={rejectConfirmation} />)}
            {selectedItem &&
                <Modal
                    closeModal={closeModal}
                    data={selectedItem}
                    height={'430px'}
                    addMode={selectedItem == 'add'}
                />
            }
            <h1>Направления для поступления</h1>

            {loading && <Loader />}

            {!loading && !list?.length
                ? <Empty />
                : <Table className={styles.tables}>
                    <thead>
                        <tr>
                            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>Наименование</th>
                            <th onClick={() => handleSort('alias')} style={{ cursor: 'pointer' }}>Кор. наименование</th>
                            <th>Удалить</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedList.map(renderLi)}
                    </tbody>
                </Table>
            }

            <div
                style={{
                    display: 'flex',
                    flexDirection: "row"
                }}>
                <Button
                    style={{
                        padding: '.5rem 1.5rem',
                        margin: '12px'
                    }}
                    onClick={openModal('add')}>
                    <IoIosAdd size={30} />
                    Добавить
                </Button>
            </div>
        </div>
    )
}
